/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import KbbPriceScreen from "../../shared/kbb-price-screen/component";
import CarDetailsInfoStrip from "../car-details-info-strip/component";
import { CLASSIFIED_BRANDING_CONSTANTS, getSellerTypeStyle, PLATFORMS, STYLE_COMPONENTS, STYLE_KEYS } from "../../../constants/app-constants";
import InfoIconSlant from "../../shared/images/info-icon-slant.svg";
import { stylesMapping } from "./constants";

const CarDetailsInfo = ({
    carName,
    bodyType,
    transmissionType,
    variant,
    egc,
    vehicleRetailPrice,
    kbbValueProvidedOn,
    showKBBModal,
    onClose,
    kilometerLabel,
    isVideoGalleryModalOpen = false,
    stripConfig = {},
    isInternalListing,
    isLuxuryCar,
    onSellerTypeInfoClick = () => {}
}) => {

    const carNameWrapperStyle = isVideoGalleryModalOpen ? "styles.videoGalleryCarNameWrapper" : "styles.carnameWrapper";
    const carNameStyle = isVideoGalleryModalOpen ? "styles.videoGalleryCarName" : "styles.carName";
    const outerContainerStyle = isVideoGalleryModalOpen ? "styles.videoGalleryOuterContainer" : "styles.outerContainer";
    const carVariantStyle = isVideoGalleryModalOpen ? "styles.videoGalleryCarVariant" : "styles.carVariant";
    const listingTypeWrapperStyle = isVideoGalleryModalOpen ? "styles.videoGalleryListingTypeWrapper" : "";
    const listingTypeTextStyle = isVideoGalleryModalOpen ? "styles.videoGalleryListingTypeText" : "";
    const separatorStyle = isVideoGalleryModalOpen ? "styles.videoGallerySeparator" : "";
    const soldByLabelStyle = isVideoGalleryModalOpen ? "styles.videoGallerySoldByLabel" : "";

    // Seller type logic
    const sellerType = isLuxuryCar ? "luxury" : isInternalListing ? "internal" : "dealer";
    const listingLabelStyle = getSellerTypeStyle(PLATFORMS.DESKTOP, STYLE_COMPONENTS.CAR_DETAIL_ATF_HEADER, STYLE_KEYS.LISTING_LABEL, isLuxuryCar, isInternalListing);
    const listingLabel = CLASSIFIED_BRANDING_CONSTANTS[sellerType].label;
    const listingLabelIcon = CLASSIFIED_BRANDING_CONSTANTS[sellerType].logo;
    const soldBy = isInternalListing ? "Cars24" : "Verified dealer";
    const topSectionStyle = !isVideoGalleryModalOpen && stripConfig?.type ? stylesMapping[stripConfig.type] : "";

    return (
        <React.Fragment>
            <div styleName={`styles.topSectionWrapper ${topSectionStyle}`}>
                {stripConfig?.type && <CarDetailsInfoStrip type={stripConfig?.type} stripInfo={stripConfig?.stripInfo} />}
                <div styleName={outerContainerStyle}>
                    <div styleName={carNameWrapperStyle}>
                        <h1 styleName={carNameStyle}> {carName} </h1>
                        <p styleName={carVariantStyle}>{variant}</p>
                    </div>
                    <ul styleName={`styles.variantList ${isVideoGalleryModalOpen ? "styles.videoGalleryVariantList" : ""}`}>
                        <li>{kilometerLabel}</li>
                        <li>{bodyType}</li>
                        <li>{transmissionType}</li>
                    </ul>
                    <div styleName={`styles.listingTypeWrapper ${listingTypeWrapperStyle}`}>
                        <img src={listingLabelIcon} alt="brand" />
                        <p styleName={`styles.listingTypeText ${listingTypeTextStyle}`}>
                            {listingLabel}
                        </p>
                        <div styleName={`styles.separator ${separatorStyle}`} />
                        <p onClick={onSellerTypeInfoClick} styleName={`${listingLabelStyle} ${soldByLabelStyle}`}>
                            Sold by {soldBy}
                            <img src={InfoIconSlant} alt="info" />
                        </p>
                    </div>
                </div>
            </div>
            {showKBBModal && (
                <KbbPriceScreen
                    onClose={onClose}
                    egc={egc}
                    vehicleRetailPrice={vehicleRetailPrice}
                    kbbValueProvidedOn={kbbValueProvidedOn}
                />
            )}
        </React.Fragment>

    );
};

CarDetailsInfo.propTypes = {
    carName: PropTypes.string.isRequired,
    odometerReading: PropTypes.number,
    bodyType: PropTypes.string,
    transmissionType: PropTypes.string,
    variant: PropTypes.string,
    serviceHistory: PropTypes.arrayOf(
        PropTypes.shape({
            serviceDate: PropTypes.string
        })
    ),
    kbbMarketPrice: PropTypes.string,
    showBelowMarket: PropTypes.bool,
    isEwVariantB: PropTypes.bool,
    handleParkedLocationClick: PropTypes.func,
    hubCityName: PropTypes.string,
    egc: PropTypes.string,
    vehicleRetailPrice: PropTypes.string,
    kbbValueProvidedOn: PropTypes.string,
    showKBBModal: PropTypes.bool,
    onClose: PropTypes.func,
    handleOpenMarketModal: PropTypes.func,
    kilometerLabel: PropTypes.string,
    defaultDiscount: PropTypes.string,
    defaultSale: PropTypes.string,
    isVideoGalleryModalOpen: PropTypes.bool,
    showPriceDrop: PropTypes.bool,
    reserved: PropTypes.bool,
    isPriceDrop: PropTypes.bool,
    stripConfig: PropTypes.object,
    isInternalListing: PropTypes.bool,
    isLuxuryCar: PropTypes.bool,
    onSellerTypeInfoClick: PropTypes.func
};

export default CarDetailsInfo;
